import axios from '@/utils/axios';
import { downloadFromAxiosResponse } from '@/utils/file-download';

// Types

export interface FilteredResponseModel<T> {
	page: number;
	itemsPerPage: number;
	totalItems: number;

	items: T[];
}

// API

export default {
	async getAgentPermissions(): Promise<any[]> {
		return (await axios().get(`/admin/permissions/`)).data;
	},

	async getLogsList(): Promise<any[]> {
		return (await axios().get(`/admin/logs/`)).data;
	},
	async downloadLogFile(name: string) {
		const axiosResponse = await axios().get(`/admin/logs/${name}/download`, { responseType: 'blob' });
		downloadFromAxiosResponse(axiosResponse, name);
	},

	async getSynchroLogsList(): Promise<any[]> {
		return (await axios().get(`/admin/logs/synchro/`)).data;
	},
	async downloadSynchroLogFile(name: string) {
		const axiosResponse = await axios().get(`/admin/logs/synchro/${name}/download`, { responseType: 'blob' });
		downloadFromAxiosResponse(axiosResponse, name);
	},

	getSynchronizationLogsList: async (page: number, itemsPerPage: number, orderBy: string[]): Promise<FilteredResponseModel<any>> => {
		return (await axios().get(`/admin/synchronization/?page=${page}&itemsPerPage=${itemsPerPage}&orderBy=${orderBy}`)).data;
	},

	async getAboutInfos(): Promise<any> {
		return (await axios().get(`/admin/about/`)).data;
	},
};
